var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Accordioncommon from "@frameworks/web/components/generic/Accordion/accordion";
import React from "react";
import Ownerprofile from "./Ownerprofile";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { useSelector } from "react-redux";
import _, { reject } from "underscore";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
var WealthAdvisorTab = function () {
    var _a, _b, _c, _d;
    var device = DeviceContext();
    var navigate = useNavigate();
    var subSection = getQueryParameterName("subSection");
    var _e = __read(React.useState(false), 2), showToast = _e[0], setShowToast = _e[1];
    var _f = __read(React.useState(""), 2), showRMName = _f[0], setshowRMName = _f[1];
    var _g = __read(React.useState(), 2), wealthDetails = _g[0], setWealthDetails = _g[1];
    var _h = useSelector(function (state) { return state.LoginFlow.ClientLoginDataReducers; }
    // _.isEqual
    ), accountsData = _h.data, accountsDataLoader = _h.loader, accountsDataError = _h.errorData;
    var welathadvisordetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                accCode: accountsData.accountCode,
                accTyp: accountsData === null || accountsData === void 0 ? void 0 : accountsData.accTyp,
            };
            di.basicProfile
                .wealthAdvisorData(payload)
                .then(function (data) {
                setWealthDetails(data);
            })
                .catch(function (err) {
                reject(err);
            });
            return [2 /*return*/];
        });
    }); };
    var wealthdetails = wealthDetails === null || wealthDetails === void 0 ? void 0 : wealthDetails.data;
    React.useEffect(function () {
        welathadvisordetails();
    }, []);
    var AllRmClientDetails = useSelector(function (state) { return state.BasicProfile.GetRmDetailsReducer; }, _.isEqual);
    var allwealthDetails = (_a = AllRmClientDetails === null || AllRmClientDetails === void 0 ? void 0 : AllRmClientDetails.data) === null || _a === void 0 ? void 0 : _a.data;
    React.useEffect(function () {
        di.basicProfile.getRmDetailsData();
    }, []);
    var WealthAdvisorTabData = [
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "grid-1 wealth-advisor-Hsection" },
                    React.createElement("span", { className: "".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "DMSansNormal_16_700 txt_blackOne1"
                            : "DMSanM_14_500 txt_blackOne1") }, "Your Account Owner"),
                    React.createElement("span", { className: "bottomsection" }, "For advice related to any of our products")))),
            eventKey: "AccountOwner",
            tabContent: (React.createElement(Ownerprofile, { OwnerName: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.accOwnerName, OwnerEmailID: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.accOwnerEmail, OwnerPhoneNo: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.accOwnerNo, title: "Rate Your Account Owner", advTyp: "ao", userRating: (_b = allwealthDetails === null || allwealthDetails === void 0 ? void 0 : allwealthDetails.ownerRatingList) === null || _b === void 0 ? void 0 : _b.userRating, setShowToast: setShowToast, setshowRMName: setshowRMName, OwnerNameTitle: "Owner Name", OwnerEmailIDTitle: "Owner Email ID", OwnerPhoneNoTitle: "Owner Phone No" })),
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "grid-1 wealth-advisor-Hsection" },
                    React.createElement("span", { className: "".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "DMSansNormal_16_700 txt_blackOne1"
                            : "DMSanM_14_500 txt_blackOne1") }, "Your Servicing RM"),
                    React.createElement("span", { className: "bottomsection" }, "For advice related to any of our products")))),
            eventKey: "RatingAdvisors",
            tabContent: (React.createElement(React.Fragment, null,
                React.createElement(Ownerprofile, { OwnerName: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.srvcRmName, OwnerEmailID: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.srvcRmEmail, OwnerPhoneNo: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.srvcRmNo, title: "Rate Your Servicing RM", advTyp: "srm", userRating: (_c = allwealthDetails === null || allwealthDetails === void 0 ? void 0 : allwealthDetails.rmRatingList) === null || _c === void 0 ? void 0 : _c.userRating, setShowToast: setShowToast, setshowRMName: setshowRMName, OwnerNameTitle: "Servicing RM Name", OwnerEmailIDTitle: "Servicing RM Email ID", OwnerPhoneNoTitle: "Servicing RM Phone No" }))),
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "grid-1 wealth-advisor-Hsection" },
                    React.createElement("span", { className: "".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "DMSansNormal_16_700 txt_blackOne1"
                            : "DMSanM_14_500 txt_blackOne1") }, "Your Equity Advisor"),
                    React.createElement("span", { className: "bottomsection" }, "For any equity related advice")))),
            eventKey: "equityAdvisor",
            tabContent: (React.createElement(Ownerprofile, { OwnerName: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.advisorName, OwnerEmailID: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.advisorEmail, OwnerPhoneNo: wealthdetails === null || wealthdetails === void 0 ? void 0 : wealthdetails.advisorNo, title: "Rate Your Advisor", advTyp: "rm", userRating: (_d = allwealthDetails === null || allwealthDetails === void 0 ? void 0 : allwealthDetails.advisorRatingList) === null || _d === void 0 ? void 0 : _d.userRating, setShowToast: setShowToast, setshowRMName: setshowRMName, OwnerNameTitle: "Advisor Name", OwnerEmailIDTitle: "Advisor Email ID", OwnerPhoneNoTitle: "Advisor Phone No" })),
        },
    ];
    return (React.createElement(React.Fragment, null,
        device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            " ",
            React.createElement(Accordioncommon, { AccordionArray: WealthAdvisorTabData, defaultActiveKey: subSection, parentClass: "common-accordian-small-content mt-4 welthadvisory-acc small-accordion-background" }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "bg-white px-3 pt-3 pb-3" },
                React.createElement(Col, { lg: 12, className: "d-flex justify-content-between pb-3 align-items-center" },
                    React.createElement("span", { className: "DMSansNormal_20_400" },
                        React.createElement("span", { className: "d-flex align-items-center mb-title", onClick: function () {
                                navigate("/profile");
                            } },
                            React.createElement("i", { className: "edel-icon-arrow-left1 pe-2" }),
                            "Your ",
                            React.createElement("strong", { className: "ps-2" }, "Wealth Advisors ")))),
                React.createElement("div", { className: "border-outer-box" },
                    React.createElement(Accordioncommon, { AccordionArray: WealthAdvisorTabData, parentClass: "common-accordian-small-content welthadvisory-acc welthadvisory-acc-mb " }))))),
        showToast && (React.createElement(React.Fragment, null,
            React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: showToast, setShow: setShowToast, position: "middle-center", message: "We\u2019ve received the rating!\n                         Thank you for rating ".concat(showRMName, ".") })))));
};
export default WealthAdvisorTab;
